const belowTwenty = [
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'eleven',
    'twelve',
    'thirteen',
    'fourteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen'
];

const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

/** 0–999 */
function numToWordsUpto999(n) {
    if (n === 0) return '';
    if (n < 20) return belowTwenty[n];
    if (n < 100) {
        const t = Math.floor(n / 10);
        const o = n % 10;
        return tens[t] + (o ? ` ${belowTwenty[o]}` : '');
    }
    const h = Math.floor(n / 100);
    const r = n % 100;
    return `${belowTwenty[h]} hundred${r ? ` ${numToWordsUpto999(r)}` : ''}`;
}

/** Indian numbering: crore, lakh, thousand, rest */
function rupeesToWords(n) {
    if (n === 0) return 'zero';
    let num = n;
    const parts = [];

    if (num >= 10000000) {
        parts.push(`${rupeesToWords(Math.floor(num / 10000000))} crore`);
        num %= 10000000;
    }
    if (num >= 100000) {
        parts.push(`${numToWordsUpto999(Math.floor(num / 100000))} lakh`.trim());
        num %= 100000;
    }
    if (num >= 1000) {
        parts.push(`${numToWordsUpto999(Math.floor(num / 1000))} thousand`.trim());
        num %= 1000;
    }
    if (num > 0) {
        parts.push(numToWordsUpto999(num).trim());
    }

    return parts.filter(Boolean).join(' ');
}

function twoDigitsPaise(n) {
    if (n < 20) return belowTwenty[n];
    const t = Math.floor(n / 10);
    const o = n % 10;
    return tens[t] + (o ? ` ${belowTwenty[o]}` : '');
}

/**
 * Converts a rupee amount to words (Indian numbering).
 */
export function amountToWordsINR(amount) {
    const num = Number(amount);
    if (amount === '' || amount === null || Number.isNaN(num)) return '';
    if (num < 0) return '';
    if (num === 0) return 'Zero Rupees Only';

    const rupees = Math.floor(num);
    const paise = Math.round((num - rupees) * 100);

    let out = `${capitalize(rupeesToWords(rupees).trim())} Rupees`;
    if (paise > 0) out += ` and ${twoDigitsPaise(paise)} Paise`;
    out += ' Only';
    return out;
}

function capitalize(s) {
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
}
